import { render, staticRenderFns } from "./CustomNavbar.vue?vue&type=template&id=a0049438&scoped=true"
import script from "./CustomNavbar.vue?vue&type=script&lang=js"
export * from "./CustomNavbar.vue?vue&type=script&lang=js"
import style0 from "./CustomNavbar.vue?vue&type=style&index=0&id=a0049438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0049438",
  null
  
)

export default component.exports